// extracted by mini-css-extract-plugin
export default {"modalZ":"100001","headerHeight":"80px","root":"pQnPS","image":"qPGt4","title":"BT5Mk","body":"HAyvU"};